import { finish, error } from '../../../modules/user/actions/forgot';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/request-password-reset', {
        email: action.email
    }).then(
        ({ data }) => dispatch(finish(data.user)),
        ({ errors }) => dispatch(error(errors))
    );
}
